import React from 'react';
import { UsersIcon, BookOpenIcon, StarIcon, MapPinIcon } from 'lucide-react';
export function SocialProofBar() {
  return <section className="bg-brand-dark text-white py-10 px-4" data-id="element-266">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-267">
        <div className="flex flex-col items-center justify-center" data-id="element-268">
          <UsersIcon className="w-10 h-10 text-brand-primary mb-3" data-id="element-269" />
          <span className="text-3xl font-black mb-1" data-id="element-270">+1.500</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-271">
            personas
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-272">
          <BookOpenIcon className="w-10 h-10 text-brand-primary mb-3" data-id="element-273" />
          <span className="text-3xl font-black mb-1" data-id="element-274">5</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-275">
            Módulos Maestros
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-276">
          <div className="flex text-brand-amber mb-3" data-id="element-277">
            <StarIcon className="w-8 h-8 fill-current" data-id="element-278" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-279" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-280" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-281" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-282" />
          </div>
          <span className="text-3xl font-black mb-1" data-id="element-283">4.9/5</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-284">
            calificación
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-285">
          <MapPinIcon className="w-10 h-10 text-brand-primary mb-3" data-id="element-286" />
          <span className="text-3xl font-black mb-1" data-id="element-287">🇦🇷</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-288">
            Todo el país
          </span>
        </div>
      </div>
    </section>;
}